import moment from "moment";

const formatFullDate = "dddd, MMMM Do YYYY";

/**
 * Relative time like "vor 5 Minuten".
 */
export const getTimeFromNow = (date: string | Date | moment.Moment): string =>
  moment(date).fromNow();

/**
 * Chat bubble time: 24h clock, e.g. "14:07".
 */
export const formatMessageTime = (
  date: string | Date | moment.Moment,
): string => moment(date).format("HH:mm");

/**
 * Returns a stable key for grouping by calendar day.
 */
export const getDayKey = (date: string | Date | moment.Moment): string =>
  moment(date).format("YYYY-MM-DD");

/**
 * Human-friendly day header for chats.
 * Heute | Gestern | dddd, DD. MMM | DD.MM.YYYY
 */
export const formatDayHeader = (
  date: string | Date | moment.Moment,
): string => {
  const m = moment(date);
  const today = moment();
  if (m.isSame(today, "day")) return "Heute";
  if (m.isSame(today.clone().subtract(1, "day"), "day")) return "Gestern";
  if (today.diff(m, "days") < 7) return m.format("dddd, DD. MMM");
  return m.format("DD.MM.YYYY");
};

/**
 * Full timestamp for tooltips/details, e.g. "DD.MM.YYYY, HH:mm".
 */
export const formatMessageTimestamp = (
  date: string | Date | moment.Moment,
): string =>
  `${moment(date).format("DD.MM.YYYY")}, ${moment(date).format("HH:mm")}`;
